<template>
  <page 
    :title="pageTitle" 
    size="is-desktop" 
    :backTo="fallbackPage"
    type="has-text-grey">
    <div slot="page-header-right">
      <coupon-magazine
        :props="{ whenUpdated: () => load() }">
      </coupon-magazine>
    </div>

    <div class="box">
      <div class="level">
        <div class="level-left">
          <div class="media" style="align-items: center;">
            <div>
              <div class="title">
                Coupon code: {{ coupon.code }}
              </div>
              <div class="subtitle">{{ "Usage type: " + coupon.usage_type }}</div>
              <div class="subtitle">{{ "Type: " + coupon.type }}</div>
              <div class="subtitle">{{ "Max users count: " + coupon.max_users_count }}</div>
            </div>
          </div>
        </div>
        <div class="columns">
          <div class="column">
            <div class="subtitle has-text-dark">
              <div>Created:  {{ calculation(coupon.created_at) }}</div>
              <div>Expires:  {{ calculation(coupon.expiry_date) }} later</div>
              <div>quantity:  {{ (coupon.quantity) }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="box">
      <b-tabs>
        <b-tab-item label="Uses">
            <b-table
              :data="coupon.uses"
              hoverable
              backend-sorting
              :default-sort="['name', 'asc']"
              detail-key="name">

              <template slot-scope="data">
                <b-table-column
                    field="user_name"
                    label="User"
                    width="300"
                    sortable
                >
                  <router-link :to="'/users/' + data.row.user.id">
                    {{ data.row.user.name}}
                  </router-link>
                </b-table-column>

                <b-table-column
                    field="model_type"
                    label="Type"
                    width="300"
                    sortable
                >
                  {{ data.row.model_type }}
                </b-table-column>

                <b-table-column
                    field="model_id"
                    label="Name"
                    width="300"
                    sortable
                >
                  {{ data.row.model_type }}
                </b-table-column>
              </template>
          </b-table>
        </b-tab-item>

        <b-tab-item label="Related magazines">
            <b-table
              :data="coupon.details"
              hoverable
              backend-sorting
              :default-sort="['name', 'asc']"
              detail-key="name">

              <template slot-scope="data">
                <b-table-column
                    field="name"
                    label="Name"
                    width="300"
                    sortable
                >
                  {{ data.row.magazine.name }}
                </b-table-column>

                <b-table-column
                  field="category"
                  label="Category">
                  {{ data.row.magazine.category.title }} <span v-if="data.row.magazine.second_category_id"> ( {{data.row.magazine.second_category.title}} ) </span> 
                </b-table-column>

                <b-table-column
                  field="issue_product_id"
                  label="Product id">
                  {{ data.row.magazine.issue_product_id }}
                </b-table-column>

                <b-table-column
                  field="issue_price"
                  label="Default price">
                  {{ data.row.magazine.issue_price }}
                </b-table-column>

                <b-table-column
                  field="control"
                  label="#">

                  <b-button
                    type="is-link"
                    @click="editMagazine(data.row.id)"
                    icon-right="pencil"/>
                  <b-modal :active.sync="editCouponMagazine" :width="640" scroll="keep">
                    <div class="card">
                      <div class="card-content">
                        <form @submit.prevent="handleSubmit(data.row.id)">
                          <div class="columns">
                            <div class="column is-6">
                              <b-field label="Magazine">
                                <magazine-selector v-model="form.magazine_id" v-if="editMag"></magazine-selector>
                                <b-field v-else>
                                  <b-input
                                    :value="couponMagazine ? couponMagazine.magazine_id : null"
                                    expanded
                                    disabled>
                                  </b-input>
                                  <p class="control">
                                    <button type="button" class="button is-primary" @click="editMag = true">Change</button>
                                  </p>
                                </b-field>
                              </b-field>
                            </div>
                            <div class="column is-6">
                              <b-field label="Magazine plan">
                                <plan-selector v-model="form.plan_id" v-if="editPlan"></plan-selector>
                                <b-field v-else>
                                  <b-input
                                    expanded
                                    :value="couponMagazine ? couponMagazine.plan_id : null"
                                    disabled>
                                  </b-input>
                                  <p class="control">
                                    <button type="button" class="button is-primary" @click="editPlan = true">Change</button>
                                  </p>
                                </b-field>
                              </b-field>
                            </div>
                            <hr/>
                          </div>
                          <hr>
                          <div class="is-pulled-right">
                            <b-button type="button" @click="editCouponMagazine = false">Cancel</b-button>
                            <button class="button is-primary">
                              <b-icon icon="content-save"></b-icon>
                              <span>save</span>
                            </button>
                          </div>

                        </form>
                        <br>
                      </div>
                    </div>
                  </b-modal>

                  <b-button
                    type="is-danger"
                    @click="destroy(data.row.magazine.id)"
                    icon-right="delete"/>
                </b-table-column>
              </template>
          
          </b-table>
        </b-tab-item>
      </b-tabs>
    </div>
  </page>
</template>

<script>
import moment from "moment";
import CouponMagazine from "./components/CouponMagazine";
export default {
  components: {
    CouponMagazine
  },
  data() {
      return {
        coupon: null,
        editCouponMagazine: false,
        createCouponMagazine: false,
        form: new window.Form({
          coupon_id: this.$route.params.id,
          magazine_id: null,
          plan_id: null
        }),
        newForm: new window.Form({
          coupon_id: this.$route.params.id,
          magazine_id: null,
          plan_id: null
        }),
        couponMagazine: null,
        editPlan: false,
        editMag: false
      }
  },
  created() {
    this.load();
  },
  computed: {
    fallbackPage() {
      return ('/magazine/coupons');
    },
    pageTitle() {
      return ('Coupon code # ' + (this.coupon ? this.coupon.code : '' ));
    }
  },

  afterMount() {
      this.calculation();
  },

  methods: {
    load() {
      this.$http
        .get("/admin/api/coupons/" + this.$route.params.id)
        .then(response => {
          this.coupon = response.data.data;
        })
        .catch(() => {
          alert("Couldn't fetch data from the server.");
        });
    },

    handleSubmit(id) {
      this.form.put('/admin/api/coupon/magazines/' + id)
        .then(() => {
          this.$buefy.toast.open({
            type: "is-success",
            message: "Successfully saved."
          });
          this.$emit("saved", this.form);
          this.form.coupon_id = null;
          this.form.magazine_id = null;
          this.form.plan_id = null;
          this.editCouponMagazine = false;
          this.load();
        });
    },

    handleSubmitCreate() {
      this.newForm.post('/admin/api/coupon/magazines')
        .then(() => {
          this.$buefy.toast.open({
            type: "is-success",
            message: "Successfully created."
          });
          this.$emit("created", this.newForm);
          this.newForm.coupon_id = null;
          this.newForm.magazine_id = null;
          this.newForm.plan_id = null;
          this.createCouponMagazine = false;
          this.load();
        });
    },

    calculation(date) {
      return moment(date).fromNow();
    },

    reload() {
      this.load();
    },

    destroy(id) {
    this.$buefy.dialog.confirm({
      title: "Remove magazine from coupon?",
      message: "Warning the deleted data wouldn't restore.",
      cancelText: "Cancel",
      confirmText: "Remove magazine",
      type: "is-danger",
      hasIcon: true,
      onConfirm: () => {
        this.$http
          .delete(`/admin/api/coupon/magazines/` + id)
          .then(() => {
            this.$buefy.toast.open("Magazine removed.");

            this.load();
          })
          .catch(error => {
            new window.FailedResponseHandler(error).handle();
          });
      }
    });
    },

    editMagazine(id) {
      this.$http
        .get("/admin/api/coupon/magazines/" + id)
        .then(response => {
          this.couponMagazine = response.data.data;
          this.form.coupon_id = this.$route.params.id;
          this.form.magazine_id = this.couponMagazine.magazine_id;
          this.form.plan_id = this.couponMagazine.plan_id;
          this.reload();
        });
      this.editCouponMagazine = true;
    },
    createMagazine() {
      this.newForm.coupon_id = this.$route.params.id;
      this.createCouponMagazine = true;
      this.reload();
    }
  }
}
</script>
